module.exports = __webpack_public_path__ + "img/lg_ring_0_0_1_1@2x.a2f24798.png";